{
  "common": {
    "ok": "OK",
    "cancel": "Annulla",
    "yes": "Sì",
    "no": "No",
    "loading": "Caricamento...",
    "error": "Errore",
    "retry": "Riprova",
    "apply": "Applica",
    "add": "Aggiungi"
  },
  "navigation": {
    "home": "Home",
    "favorites": "Preferiti",
    "search": "Cerca"
  },
  "jobs": {
    "noJobs": "Nessun lavoro trovato",
    "loadMore": "Carica altro",
    "apply": "Candidati",
    "save": "Salva",
    "unsave": "Rimuovi"
  },
  "search": {
    "placeholder": "Cerca lavori...",
    "filter": "Filtra",
    "clear": "Cancella",
    "open": "Cerca lavori",
    "close": "Chiudi ricerca"
  },
  "alerts": {
    "title": "Avvisi di lavoro",
    "subtitle": "Ricevi una notifica quando compaiono nuove offerte che corrispondono alla ricerca.",
    "placeholder": "Parole chiave (es. react remoto senior)",
    "empty": "Nessun avviso",
    "matchingNow": "{{count}} corrispondono ora"
  },
  "description": {
    "openUrlMessage": "Apri URL per ulteriori informazioni",
    "postedOn": "Pubblicato il",
    "applyViewDetails": "Candidati / Visualizza dettagli"
  },
  "error": {
    "title": "Qualcosa è andato storto",
    "description": "Spiacenti, nessun lavoro trovato! Probabilmente è un errore di server o di rete.",
    "tryAgain": "Riprova"
  },
  "filter": {
    "refineJobs": "Raffina lavori",
    "title": "Filtra",
    "total": "totale",
    "reset": "Ripristina",
    "filterByDate": "Filtra per data",
    "byDate": "Per data",
    "byApplied": "Per candidature",
    "appliedOnlyOn": "Solo candidature: attivo",
    "appliedOnlyOff": "Solo candidature: disattivo",
    "postedAfter": "Pubblicato dopo il",
    "filterByTags": "Filtra per tag",
    "byTag": "Per tag",
    "clearAllFavorites": "Cancella tutti i preferiti",
    "applyFilters": "Applica filtri"
  },
  "share": {
    "message": "Ecco una grande opportunità di lavoro remoto:\n* Posizione: {{position}}\n* Azienda: {{company}}\n* URL: {{url}}",
    "title": "App Lavoro Remoto - {{position}} @{{company}}",
    "subject": "Lavoro condiviso da App Lavoro Remoto",
    "dialogTitle": "Condividi un lavoro remoto"
  },
  "datepicker": {
    "selectDate": "Seleziona Data",
    "year": "Anno",
    "month": "Mese",
    "previousMonth": "Mese precedente",
    "nextMonth": "Mese successivo",
    "weekdays": [
      "Dom",
      "Lun",
      "Mar",
      "Mer",
      "Gio",
      "Ven",
      "Sab"
    ],
    "months": [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ]
  },
  "tabs": {
    "allJobs": "Tutti i Lavori",
    "favorites": "Preferiti",
    "resumeBuilder": "Curriculum",
    "applications": "Candidature",
    "profile": "Profilo"
  },
  "favorites": {
    "deleteAll": "Elimina tutti i Preferiti",
    "empty": "Ancora nessun preferito. Tocca il cuore di un lavoro per salvarlo qui."
  },
  "icons": {
    "jobActions": "Azioni Lavoro",
    "addToFavorites": "Aggiungi ai Preferiti",
    "removeFromFavorites": "Rimuovi dai Preferiti",
    "share": "Condividi",
    "openUrl": "Apri URL",
    "markApplied": "Segna come Candidato",
    "removeApplied": "Rimuovi Candidatura"
  },
  "job": {
    "applied": "Candidato",
    "fit": "Affinità {{score}}%"
  },
  "list": {
    "found": "trovati"
  },
  "onboarding": {
    "tagline": "Scopri opportunità remote selezionate da tutto il mondo!",
    "next": "Avanti"
  },
  "tour": {
    "skip": "Salta",
    "next": "Avanti",
    "getStarted": "Inizia",
    "slides": {
      "welcome": {
        "title": "Benvenuto",
        "description": "Un tour rapido delle funzioni principali per trovare il tuo prossimo lavoro da remoto più in fretta."
      },
      "search": {
        "title": "Cerca e filtra le offerte",
        "description": "Cerca per parola chiave e affina i risultati per data, tag o stato della candidatura."
      },
      "favorites": {
        "title": "Preferiti e candidature",
        "description": "Tocca il cuore per salvare un'offerta e segna quelle a cui ti sei già candidato."
      },
      "tracker": {
        "title": "Tieni traccia delle candidature",
        "description": "Segna i lavori come candidati e segui ciascuno per fasi — colloquio, offerta — con note e date."
      },
      "alerts": {
        "title": "Ricevi avvisi sulle nuove offerte",
        "description": "Salva una ricerca e ricevi una notifica quando nuovi lavori da remoto corrispondono alle tue parole chiave."
      },
      "resume": {
        "title": "Crea il tuo curriculum",
        "description": "Crea un curriculum professionale, esportalo in PDF o DOCX e scopri quanto ogni lavoro è in linea con le tue competenze."
      },
      "account": {
        "title": "Accedi per sincronizzare",
        "description": "Crea un account gratuito per salvare curriculum, candidature, preferiti e avvisi su tutti i dispositivi."
      },
      "settings": {
        "title": "Temi e lingue",
        "description": "Passa tra chiaro e scuro e scegli tra 9 lingue nelle impostazioni."
      }
    }
  },
  "theme": {
    "toggle": "Cambia tema"
  },
  "settings": {
    "title": "Impostazioni",
    "theme": "Tema",
    "themeLight": "Chiaro",
    "themeDark": "Scuro",
    "language": "Lingua",
    "open": "Apri impostazioni",
    "close": "Chiudi",
    "developer": "Sviluppatore",
    "hideAds": "Nascondi annunci",
    "removeAds": {
      "title": "Rimuovi annunci",
      "buy": "Rimuovi annunci — {{price}}",
      "restore": "Ripristina acquisti",
      "purchased": "Grazie per supportare RemoteWork! Gli annunci sono disattivati.",
      "successTitle": "Annunci rimossi",
      "successMessage": "Grazie per il tuo supporto! Gli annunci sono ora disattivati in tutta l'app.",
      "errorTitle": "Acquisto non riuscito",
      "errorMessage": "Qualcosa è andato storto. Riprova.",
      "restoreEmptyTitle": "Nulla da ripristinare",
      "restoreEmptyMessage": "Nessun acquisto precedente trovato su questo account."
    },
    "tour": "Tour",
    "replayTour": "Rivedi il tour",
    "account": "Account",
    "deleteAccount": {
      "action": "Elimina account",
      "confirmTitle": "Eliminare l'account?",
      "confirmMessage": "Questo elimina definitivamente il tuo account e tutti i dati sincronizzati — curriculum, candidature, preferiti e avvisi. Non è reversibile.",
      "errorTitle": "Impossibile eliminare l'account",
      "errorMessage": "Qualcosa è andato storto. Riprova.",
      "reauthMessage": "Per la tua sicurezza, esci e accedi di nuovo, poi riprova a eliminare l'account."
    },
    "about": "Informazioni",
    "privacyPolicy": "Informativa sulla privacy",
    "website": "Visita il sito web"
  },
  "ad": {
    "sponsored": "Sponsorizzato"
  },
  "consent": {
    "message": "Utilizziamo cookie di analisi per capire come viene usato il sito. Restano disattivati finché non accetti.",
    "accept": "Accetta",
    "reject": "Rifiuta"
  },
  "disclaimer": {
    "title": "Informazioni sugli annunci di lavoro",
    "message": "Le offerte mostrate in questa app provengono da fonti di terze parti e API pubbliche. Non pubblichiamo, selezioniamo né controlliamo questi annunci e non possiamo garantire l'accuratezza, la qualità o la disponibilità di alcuna posizione. Verifica sempre i dettagli direttamente con il datore di lavoro prima di candidarti.",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "Generatore di Curriculum",
    "newResume": "Nuovo",
    "newResumePrompt": "Dai un nome al tuo curriculum",
    "namePlaceholder": "Es.: CV Frontend",
    "lastModified": "Ultima modifica",
    "discardTitle": "Annullare le modifiche?",
    "discardMessage": "Hai modifiche non salvate.",
    "webPlaceholder": {
      "title": "Il generatore di curriculum è disponibile solo su mobile",
      "subtitle": "Apri l'app su Android o iOS per creare ed esportare il tuo curriculum."
    },
    "actions": {
      "edit": "Modifica",
      "duplicate": "Duplica",
      "delete": "Elimina",
      "more": "Altre opzioni",
      "deleteConfirmTitle": "Eliminare il curriculum?",
      "deleteConfirmMessage": "Eliminare definitivamente \"{{name}}\"? L'operazione è irreversibile."
    },
    "empty": {
      "title": "Ancora nessun curriculum",
      "subtitle": "Crea un curriculum professionale ed esportalo come PDF o DOCX.",
      "cta": "Crea il tuo primo curriculum",
      "skillsHint": "Aggiungi competenze come JavaScript, design, leadership…"
    },
    "sections": {
      "personalInfo": "Dati personali",
      "experience": "Esperienza",
      "education": "Istruzione",
      "skills": "Competenze",
      "languages": "Lingue",
      "links": "Link",
      "template": "Modello",
      "contact": "Contatti",
      "summary": "Riassunto",
      "personalization": "Personalizzazione",
      "preview": "Anteprima"
    },
    "fields": {
      "fullName": "Nome completo",
      "title": "Titolo professionale",
      "email": "Email",
      "phone": "Telefono",
      "location": "Località",
      "website": "Sito web",
      "summary": "Profilo professionale",
      "company": "Azienda",
      "position": "Posizione",
      "institution": "Istituto",
      "degree": "Titolo",
      "field": "Ambito di studio",
      "startDate": "Inizio",
      "endDate": "Fine",
      "current": "Lavoro qui attualmente",
      "present": "In corso",
      "description": "Descrizione",
      "skillPlaceholder": "Aggiungi una competenza",
      "languageName": "Lingua",
      "languageProficiency": "Livello",
      "linkLabel": "Etichetta",
      "linkUrl": "URL",
      "phoneCountryCode": "Prefisso paese"
    },
    "proficiency": {
      "basic": "Base",
      "conversational": "Conversazione",
      "fluent": "Fluente",
      "native": "Madrelingua"
    },
    "templates": {
      "modern": "Moderno",
      "classic": "Classico",
      "minimal": "Minimal",
      "modernDescription": "Layout a due colonne con barra laterale colorata.",
      "classicDescription": "Tradizionale in bianco e nero, colonna singola.",
      "minimalDescription": "Pulito, molto spazio bianco, senza colori."
    },
    "buttons": {
      "addExperience": "Aggiungi esperienza",
      "addEducation": "Aggiungi istruzione",
      "addLanguage": "Aggiungi lingua",
      "addLink": "Aggiungi link",
      "remove": "Rimuovi",
      "save": "Salva",
      "discard": "Annulla",
      "export": "Esporta",
      "exportPdf": "Esporta come PDF",
      "exportDocx": "Esporta come DOCX",
      "create": "Crea",
      "previous": "Precedente",
      "next": "Avanti"
    },
    "export": {
      "preparing": "Preparazione del file…",
      "preparingHint": "Scegli un formato. Il file si aprirà nel menu di condivisione.",
      "errorTitle": "Esportazione non riuscita",
      "errorMessage": "Si è verificato un problema durante l'esportazione del curriculum."
    },
    "validation": {
      "invalidEmail": "Inserisci un'email valida.",
      "invalidCountryCode": "Fino a 4 cifre, eventualmente precedute da +.",
      "invalidWebsite": "Inserisci un sito web valido (es. esempio.com)."
    },
    "personalization": {
      "title": "Personalizza",
      "colorMode": "Tema colore",
      "modes": {
        "light": "Chiaro",
        "dark": "Scuro"
      },
      "fontFamily": "Font",
      "fonts": {
        "sans": "Sans",
        "serif": "Serif",
        "modern": "Moderno",
        "mono": "Mono"
      },
      "fontSize": "Dimensione font",
      "sizes": {
        "title": "Titolo",
        "subtitle": "Sottotitolo",
        "body": "Testo"
      },
      "increase": "Aumenta {{field}}",
      "decrease": "Diminuisci {{field}}"
    },
    "photo": {
      "placeholder": "Nessuna foto",
      "choose": "Aggiungi foto",
      "change": "Cambia foto",
      "remove": "Rimuovi",
      "permissionTitle": "Autorizzazione richiesta",
      "permissionMessage": "Consenti l’accesso alla galleria per scegliere una foto profilo."
    }
  },
  "sort": {
    "recent": "Più recenti",
    "bestFit": "Migliore affinità",
    "toggle": "Ordina per affinità"
  },
  "applyKit": {
    "title": "Kit di candidatura",
    "hint": "Tocca per copiare e incollare nel modulo.",
    "copied": "Copiato",
    "openExternal": "Apri nel browser"
  },
  "applications": {
    "title": "Candidature",
    "empty": {
      "title": "Nessuna candidatura",
      "subtitle": "Le offerte a cui ti candidi compaiono qui per seguirne lo stato."
    },
    "status": {
      "applied": "Candidato",
      "interviewing": "Colloquio",
      "offer": "Offerta",
      "rejected": "Rifiutato"
    },
    "notesPlaceholder": "Aggiungi note…",
    "remove": "Rimuovi",
    "removeConfirm": "Rimuovere questa candidatura?",
    "lastUpdate": "Ultimo aggiornamento: {{date}}",
    "editDate": "Modifica data",
    "addManual": "Aggiungi candidatura"
  },
  "auth": {
    "account": "Account",
    "signIn": "Accedi",
    "signUp": "Crea account",
    "signOut": "Esci",
    "title": {
      "signIn": "Bentornato",
      "signUp": "Crea il tuo account"
    },
    "email": "E-mail",
    "password": "Password",
    "showPassword": "Mostra password",
    "hidePassword": "Nascondi password",
    "forgotPassword": "Password dimenticata?",
    "resetSent": "E-mail di reimpostazione inviata — controlla la posta.",
    "enterEmailFirst": "Inserisci prima la tua e-mail.",
    "noAccount": "Non hai un account? Creane uno",
    "haveAccount": "Hai già un account? Accedi",
    "criteria": {
      "minLength": "Almeno 8 caratteri",
      "uppercase": "Una lettera maiuscola",
      "lowercase": "Una lettera minuscola",
      "numeric": "Un numero",
      "special": "Un carattere speciale"
    },
    "errors": {
      "invalid-email": "Questa e-mail non sembra valida.",
      "invalid-credential": "E-mail o password non corretti.",
      "user-not-found": "Nessun account trovato con questa e-mail.",
      "wrong-password": "E-mail o password non corretti.",
      "email-already-in-use": "Esiste già un account con questa e-mail.",
      "weak-password": "La password non soddisfa i requisiti.",
      "requires-recent-login": "Accedi di nuovo per continuare.",
      "too-many-requests": "Troppi tentativi. Riprova più tardi.",
      "network": "Errore di rete. Controlla la connessione.",
      "not-configured": "Accesso non disponibile al momento.",
      "unknown": "Qualcosa è andato storto. Riprova."
    },
    "continueGoogle": "Continua con Google",
    "continueApple": "Continua con Apple",
    "or": "o",
    "loggedInAnonymous": "Accesso anonimo",
    "continueAnonymous": "Continua in anonimo",
    "loggedOutWarning": "Non hai effettuato l'accesso — i tuoi dati sono solo su questo dispositivo e potrebbero andare persi."
  },
  "profile": {
    "title": "Profilo",
    "signInRegister": "Accedi / Registrati",
    "more": "Altro"
  },
  "applyBrowser": {
    "title": "Candidati"
  }
}
